import { HabitSortingMode, SortingMode } from '@griply/types';

export const habitSortingModeToSortingMode: Record<
  HabitSortingMode,
  SortingMode
> = {
  [HabitSortingMode.Custom]: SortingMode.Custom,
  [HabitSortingMode.Priority]: SortingMode.Priority,
};
